export enum AppScreen {
  MobileSmall = 'MobileSmall', // 360–389
  Mobile = 'Mobile', // 390–479
  MobileLarge = 'MobileLarge', // 480–599
  TabletSmall = 'TabletSmall', // 600–759
  TabletLarge = 'TabletLarge', // 760–1023
  Desktop = 'Desktop', // 1024–1439
  DesktopLarge = 'DesktopLarge', // 1440–1919
  Wide = 'Wide', // ≥1920
}

export const ModernBreakpoints: Record<AppScreen, string> = {
  [AppScreen.MobileSmall]: '(min-width: 360px) and (max-width: 389.98px)',
  [AppScreen.Mobile]: '(min-width: 390px) and (max-width: 479.98px)',
  [AppScreen.MobileLarge]: '(min-width: 480px) and (max-width: 599.98px)',
  [AppScreen.TabletSmall]: '(min-width: 600px) and (max-width: 759.98px)',
  [AppScreen.TabletLarge]: '(min-width: 760px) and (max-width: 1023.98px)',
  [AppScreen.Desktop]: '(min-width: 1024px) and (max-width: 1439.98px)',
  [AppScreen.DesktopLarge]: '(min-width: 1440px) and (max-width: 1919.98px)',
  [AppScreen.Wide]: '(min-width: 1920px)',
};

export const ALL_BREAKPOINTS = Object.values(ModernBreakpoints);
